module.exports = __webpack_public_path__ + "img/days-trial.aca3fb51.png";